/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from 'react';
import clsx from 'clsx';

import { ForecastListItem } from '@futrli-sdk/predict';
import { ConsolidatedForecastListItem } from '@futrli-sdk/consolidations';

import { LineBarData } from '../../types';

import styles from './custom-legend.scss';

interface Props {
  forecasts: (ForecastListItem | ConsolidatedForecastListItem)[];
  lineBarData: LineBarData;
  forecastStartLineColors?: { id: string; color: string }[];
}
const max_accounts = 12;

export const BarLineCustomLegend: FC<Props> = ({ lineBarData, forecasts, forecastStartLineColors = [] }) => {
  return (
    <div className={clsx(styles.legendContainer, styles.barLineLegend)}>
      <div
        className={
          (lineBarData.colors.length || 1) >= max_accounts ? styles.heavyLegendContent : styles.thinLegendContent
        }
      >
        {(lineBarData.colors?.length || 1) >= max_accounts
          ? forecasts.map(f => (
              <div className={styles.forecastNameContainer} key={f.id}>
                {forecasts.length > 1 && (
                  <b
                    className={styles.forecast}
                    style={{ color: forecastStartLineColors.find(d => d.id === f.id)?.color || '#000' }}
                  >
                    {f.name}
                  </b>
                )}
                <div className={styles.labelsContainer}>
                  {(lineBarData.colors || [])
                    .filter(d => d.forecastId === f.id)
                    .map((d, li) => {
                      return (
                        <div className={styles.label} key={`${f.id}-${d.key}-${li}`}>
                          <span className={styles.labelColor} style={{ backgroundColor: d.color }}></span>
                          <span className={styles.labelName}>{d.name}</span>
                        </div>
                      );
                    })}
                </div>
              </div>
            ))
          : forecasts.map(f => (
              <div
                className={forecasts.length > 1 ? styles.forecastNameContainer : styles.forecastContainer}
                key={f.id}
              >
                {forecasts.length > 1 && (
                  <b
                    className={styles.forecast}
                    style={{ color: forecastStartLineColors.find(d => d.id === f.id)?.color || '#000' }}
                  >
                    {f.name}
                  </b>
                )}
                {(lineBarData.colors || [])
                  .filter(d => d.forecastId === f.id)
                  .map((d, li) => {
                    return (
                      <div className={styles.label} key={`${f.id}-${d.key}-${li}`}>
                        <span className={styles.labelColor} style={{ backgroundColor: d.color }}></span>
                        <span className={styles.labelName}>{d.name}</span>
                      </div>
                    );
                  })}
              </div>
            ))}
      </div>
    </div>
  );
};
